import React from "react";
import { XStack } from "tamagui";
import { useStores } from "../../core/stores";
import { Box } from "../../ui/Box";
import { Button } from "../../ui/Button";

export const BusinessAdmin = ({
  businessPlanUid,
}: {
  businessPlanUid: string;
}) => {
  const { businessPlansStore, sessionStore } = useStores();

  const businessPlan = businessPlansStore.byId.get(businessPlanUid);

  if (!sessionStore.isDev) {
    return null;
  }

  return (
    <Box>
      <XStack gap={"$medium"} flexWrap={"wrap"}>
        {businessPlan && (
          <>
            <Button
              onPress={() => {
                businessPlan.joinWithCurrentSuperUser();
              }}
            >
              Join Business
            </Button>

            <Button
              onPress={() => {
                if (businessPlan.userInPlan?.uid) {
                  businessPlan.toggleMemberRole(
                    businessPlan.userInPlan.uid,
                    "admin",
                  );
                }
              }}
            >
              Toggle isAdmin {businessPlan.hasAdminAccess ? "ON" : "OFF"}
            </Button>

            <Button
              onPress={() => {
                businessPlan.userInPlan?.setPlanUid("");
              }}
            >
              Leave private planira
            </Button>
          </>
        )}
      </XStack>
    </Box>
  );
};
